/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { TreeNode } from '@ali-hm/angular-tree-component';

/**
 * This is an extension of <code>tree-node</code> component which allows DnD in heteragenous environment.
 */
@Component({
  standalone: false,
  selector: 'gh-tree-node-dnd',
  templateUrl: 'tree-node-dnd.component.html',
})
export class TreeNodeDndComponent {
  @Input() node: TreeNode;
  @Input() index: number;
  @Input() templates: any;
}
